module.exports = __webpack_public_path__ + "img/lystit.a40c9d70.png";